import { render, staticRenderFns } from "./AddBooking.vue?vue&type=template&id=2045d560&scoped=true"
import script from "./AddBooking.vue?vue&type=script&lang=js"
export * from "./AddBooking.vue?vue&type=script&lang=js"
import style0 from "./AddBooking.vue?vue&type=style&index=0&id=2045d560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045d560",
  null
  
)

export default component.exports